export const APP_NAME = 'app-distribute';
